import React, {createContext, useEffect} from 'react';
import './App.css';
import {theme} from "./Tema";
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import {ThemeProvider} from "@mui/system";
import {useEscucharUsuarioToCorreo} from "./Servicios/BD/useEscucharUsuarioToCorreo";
import {useEscucharAuth} from "./Servicios/Auth/Hooks/useEscucharAuth";
import Login from "./Login/Login";
import logo from './Recursos/logo_oscuro.svg'
import logo_redondo from './Recursos/logo_redondo.svg'
import {Grid} from "@mui/material";
import Dashboard from "./Dashboard/Dashboard";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, query} from "firebase/firestore";
import {fire} from "./fire";


export const usuarioContext = createContext();

function App() {
    const {email, data} = useEscucharAuth()
    const {usuario} = useEscucharUsuarioToCorreo({correo: email, user: data})
    const {data: configCrm, actualizarDataLocal: actConfigCrm} = useObtenerDataActualizada({
        clave: 'configCrm',
    })
    const {data: programas, actualizarDataLocal: actProgramas} = useObtenerDataActualizada({
        clave: 'programas',
    })
    const {data: escuelas, actualizarDataLocal: actEscuelas} = useObtenerDataActualizada({
        clave: 'escuelas',
    })


    const valoresProvider = {
        usuario,
        configCrm,
        programas,
        escuelas
    }

    const {Provider} = usuarioContext;


    useEffect(() => {


        if (window.swUpdateReady) {
            window.swUpdateReady = false;
            window.stop();
            window.location.reload();
        }


        obtenerFechaAct('configCrm').then((dox) => {
            let w = []
            let q = query(collection(fire, 'configCrm'), ...w)
            actConfigCrm({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('escuelas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'escuelas'), ...w)
            actEscuelas({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('programas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'programas'), ...w)
            actProgramas({fecha: dox, wheres: w, query: q}).then()
        })

    }, [])


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Provider value={valoresProvider}>
                {usuario ?
                    <ThemeProvider theme={theme}>
                        <Dashboard/>
                    </ThemeProvider>

                    :
                    <Login logo={logo} logoRedondo={logo_redondo}/>
                }

            </Provider>
        </Grid>
    );
}

export default App;
